import type { WorkOrderId } from "../lib/workIds";
import {
  type CreateWorkOrderDraft,
  useAttachCreatedWorkOrderProcedureMutation,
  useCreateWorkOrderMutation,
} from "../mutations/useCreateWorkOrderMutation";

export type AssetWorkOrderDraft = CreateWorkOrderDraft;

/**
 * Shared "create a Work Order, then optionally attach a Procedure" flow
 * backing `AssetWorkOrderModal` on the Work Orders, Asset detail and Assets
 * screens. Both steps go through mutation hooks, which own their toasts.
 */
export function useAssetWorkOrderCreation() {
  const createMutation = useCreateWorkOrderMutation();
  const attachMutation = useAttachCreatedWorkOrderProcedureMutation();

  async function createWorkOrder(
    draft: AssetWorkOrderDraft,
  ): Promise<WorkOrderId> {
    const created = await createMutation.mutateAsync(draft);
    return created.id;
  }

  async function attachProcedure(
    workOrderId: WorkOrderId,
    procedureId: string,
  ): Promise<void> {
    await attachMutation.mutateAsync({ workOrderId, procedureId });
  }

  return { createWorkOrder, attachProcedure };
}
